import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { IBranchMastDropdown, IClientCategoriesDropdown, IClientCompanyDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { JobType, Term, Priority, InterviewProcess, ServedStatus, Status } from "../../models/FDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ILogin } from "../../models/Login";
import { JVDropdownInput } from "../../shared/JVDropdownInput";

export interface IIncentiveFilter {
    month?: Date | null,
    company?: number | null,
    branchName?: string | null,
    prime_Vendor_Company?: any | string | null,
    consultant_ID?: any | string | null,
    paymentStatus?: string | null,
};

export const EmptyFilter: IIncentiveFilter = {
    month: new Date(),
    company: null,
    branchName: null,
    prime_Vendor_Company: null,
    consultant_ID: null,
    paymentStatus: null
};

const Payment_Status = [
    { name: "-- SELECT --", value: null },
    { name: "Pending", value: "Pending" },
    // { name: "Un Paid", value: "Un Paid" },
];

const schema = yup.object({
    month: yup.date().nullable(),
    company: yup.number().nullable(),
    branchName: yup.string().nullable(),
    prime_Vendor_Company: yup.number().nullable(),
    consultant_ID: yup.number().nullable(),
    paymentStatus: yup.string().nullable(),
});

const branches = [
    { name: "Varanasi" },
    { name: "Agra" },
    { name: "Noida" },
    { name: "Bhubaneswar" },
    { name: "Meerut" },
    { name: "Ranchi" },
];

interface IProps {
    incentiveFilter: IIncentiveFilter,
    setIncentiveFilter: (incentiveFilter: IIncentiveFilter) => void,
    toast: any,
    generated?: boolean
};

export const Filter = (props: IProps) => {
    const [sales, setSales] = useState<Array<IUsersDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    // const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [consultant, setConsultant] = useState<Array<any>>();
    const [vendor_Company, setVendor_Company] = useState<Array<any>>();


    const { control, handleSubmit, reset, watch } = useForm<IIncentiveFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.incentiveFilter,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadSales = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSales(data);
        }
    }

    const loadRecruiters = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerList", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }

    // const loadBranches = async (company?: number | null | undefined) => {
    //     let queryParam = company ? `company_id=${company}` : null;
    //     let endPoint = loginObj.id === 1346 ? "allBranches" : "reqBranchList";

    //     const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
    //     if (response) {
    //         const data: Array<IBranchMastDropdown> = await response.json();
    //         const emptyData = {
    //             branch_ID: 0,
    //             branchName: "-- SELECT --",
    //             company_ID: 0
    //         };
    //         data.unshift(emptyData);
    //         setBranches(data);
    //     }
    // }

    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    useEffect(() => {
        loadSales(0, 0, 0);
        loadRecruiters(0, 0, 0);
        loadCompanies();
        // loadBranches();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0) {
                    // loadBranches(value.company);
                    // loadSales(0, value.company, 0);
                    // loadRecruiters(0, value.company, 0);
                } else {
                    // loadBranches();
                    if (control._formValues.branch != 0) {
                    } else if (control._formValues.branch == 0) {
                    }

                    // if (control._formValues.branch != 0 && control._formValues.team != 0) {
                    //     loadRecruiters(0, 0, control._formValues.team);
                    // } else if (control._formValues.branch == 0 && control._formValues.team != 0) {
                    //     loadRecruiters(0, 0, control._formValues.team);
                    // } else if (control._formValues.branch != 0 && control._formValues.team == 0) {
                    //     loadRecruiters(control._formValues.branch, 0, 0);
                    // } else if (control._formValues.branch == 0 && control._formValues.team == 0) {
                    //     loadRecruiters(0, 0, 0);
                    // }
                }
            }

            // if (name === "branch") {
            //     if (value.branch != 0) {
            //         loadSales(value.branch, 0, 0);
            //         loadRecruiters(value.branch, 0, 0);
            //     } else {
            //         if (control._formValues.company != 0) {
            //         } else if (control._formValues.company == 0) {
            //         }

            //         if (control._formValues.company != 0 && control._formValues.team != 0) {
            //             loadRecruiters(0, 0, control._formValues.team);
            //         } else if (control._formValues.company == 0 && control._formValues.team != 0) {
            //             loadRecruiters(0, 0, control._formValues.team);
            //         } else if (control._formValues.company != 0 && control._formValues.team == 0) {
            //             loadRecruiters(0, control._formValues.company, 0);
            //         } else if (control._formValues.company == 0 && control._formValues.team == 0) {
            //             loadRecruiters(0, 0, 0);
            //         }
            //     }
            // }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    // useEffect(() => {
    //     if (control._formValues.company === 0 && control._formValues.branch === 0 && control._formValues.team === 0) {
    //         loadSales(0, 0, 0);
    //     }
    //     if (control._formValues.company != 0 && control._formValues.branch != 0 && control._formValues.team === 0) {
    //         loadSales(control._formValues.branch, 0, 0);
    //     }
    //     if (control._formValues.company != 0 && control._formValues.branch === 0 && control._formValues.team != 0) {
    //         loadSales(0, 0, control._formValues.team);
    //     }
    //     if (control._formValues.company === 0 && control._formValues.branch != 0 && control._formValues.team != 0) {
    //         loadSales(0, 0, control._formValues.team);
    //     }
    // }, [control._formValues.company, control._formValues.branch, control._formValues.team]);

    const searchToDB = async (body: IIncentiveFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        filterData.consultant_ID = filterData?.consultant?.consultant_ID;
        filterData.prime_Vendor_Company = filterData?.vendor_Company?.vendor_Company_ID;
        body = filterData;

        props.setIncentiveFilter(body);
    }

    function onSubmit(data: IIncentiveFilter) {
        searchToDB(data);
    }

    const loadVendorCompany = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/vendorCompanyBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                vendor_Company_ID: 0,
                vendor_Company_Name: "-- SELECT --",
            };

            data.unshift(emptyData);
            setVendor_Company(data);
        }
    };

    const completeMethodVemdorCompany = (event: { query: string }) => {
        loadVendorCompany(event.query);
    }

    const loadConsultant = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/consultantBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setConsultant(data);
        }
    };

    const completeMethodConsultant = (event: { query: string }) => {
        loadConsultant(event.query);
    }

    const Clear = () => {
        reset(EmptyFilter);
        // loadSales(0, 0, 0);
        // loadRecruiters(0, 0, 0);
        // loadBranches();
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate column={6} label="Month & Year" type="month-year" control={control} name="month" />
            <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <JVDropdown column={6} label="Branch" control={control} name="branchName" options={branches} optionLabel="name" optionValue="name" placeholder="Select Branch" />
            {/* <JVDropdown column={6} label="Sales Manager" filter control={control} name="req_PostedBySalesManager" options={sales} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" /> */}
            {/* <JVDropdown column={6} label="Recruiter" filter control={control} name="req_SubmittedByRecruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" /> */}
            {(props.generated === undefined || props.generated === null) && <JVDropdownInput column={6} label="Prime Vendor Company" completeMethod={completeMethodVemdorCompany} control={control} name="vendor_Company" options={vendor_Company} optionLabel="vendor_Company_Name" placeholder="Search Prime Vendor Company" />}
            {(props.generated === undefined || props.generated === null) && <JVDropdownInput column={6} label="Consultant Name" completeMethod={completeMethodConsultant} control={control} name="consultant" options={consultant} optionLabel="consultant_Name" placeholder="Search " />}
            {(props.generated === undefined || props.generated === null) && <JVDropdown column={6} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" />}

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={Clear} type="button"></Button>
            </div>
        </form>

    );
}